module.exports = __webpack_public_path__ + "img/berlev.c0768003.jpg";